import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Typography,
  Button,
  IconButton,
  CircularProgress,
  Alert,
  Container,
  Card
} from '@mui/material';
import {
  Delete,
  Add,
  Remove,
  ArrowBack
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import useCart from '../hooks/useCart';





const Cart = () => {
    const navigate = useNavigate();
    const { cart, cartCount, removeFromCart, updateQuantity, clearCart } = useCart();
    const [cartItems, setCartItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const loadCartItems = useCallback(async () => {
        try {
            setLoading(true);
            
            if (cart.length === 0) {
                setCartItems([]);
                setLoading(false);
                return;
            }
            
            // Группируем товары по странам для оптимизации запросов
            const groupedByCountry = {};
            cart.forEach(item => {
                if (!groupedByCountry[item.country]) {
                    groupedByCountry[item.country] = [];
                }
                groupedByCountry[item.country].push(item);
            });
            
            const itemsWithData = [];
            
            // Обрабатываем каждую страну отдельно
            for (const [countryCode, countryItems] of Object.entries(groupedByCountry)) {
                try {
                    // Получаем список ID товаров для данной страны
                    const productIds = countryItems.map(item => item.spuId);
                    
                    // Используем новый endpoint для получения данных товаров корзины
                    const response = await fetch('https://api.dudu-shopping.ru:3001/api/cart-products', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ 
                            productIds, 
                            countryCode 
                        })
                    });
                    
                    if (!response.ok) {
                        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
                    }
                    
                    const data = await response.json();
                    
                    if (data.success && data.products) {
                        // Сопоставляем полученные данные с товарами корзины
                        countryItems.forEach(cartItem => {
                            const productData = data.products.find(p => p.spuId === cartItem.spuId);
                            
                                                    if (productData && productData.product) {
                            const product = productData.product;
                            
                            // Находим выбранный цвет
                            const color = product.colors?.find(c => c.name === cartItem.color);
                            if (!color) {
                                // Показываем товар с ошибкой
                                const errorItem = {
                                    ...cartItem,
                                    product: { name: product.name || 'Название недоступно', displayReference: product.displayReference || 'N/A' },
                                    displayPrice: 0,
                                    displayImage: null,
                                    isAvailable: false,
                                    error: 'Цвет не найден'
                                };
                                itemsWithData.push(errorItem);
                                return;
                            }
                            
                            // Находим выбранный размер
                            const size = color.sizes?.find(s => s.name === cartItem.size);
                            if (!size) {
                                // Показываем товар с ошибкой
                                const errorItem = {
                                    ...cartItem,
                                    product: { name: product.name || 'Название недоступно', displayReference: product.displayReference || 'N/A' },
                                    displayPrice: 0,
                                    displayImage: null,
                                    isAvailable: false,
                                    error: 'Размер не найден'
                                };
                                itemsWithData.push(errorItem);
                                return;
                            }
                            
                            // Проверяем доступность
                            if (size.availability === 'out_of_stock') {
                                // Можно показать предупреждение, но не удалять из корзины
                            }
                                
                                // Получаем актуальную цену
                                const currentPrice = size.price || color.price || 0;
                                
                                // Получаем изображение
                                const displayImage = color.images && color.images.length > 0 ? color.images[0] : null;
                                
                                const itemWithData = {
                                    ...cartItem,
                                    product: {
                                        name: product.name || 'Название недоступно',
                                        displayReference: product.displayReference || 'N/A',
                                        brand: product.brand || 'Zara',
                                        article: product.displayReference || 'N/A'
                                    },
                                    color: color.name,
                                    size: size.name,
                                    displayPrice: currentPrice,
                                    displayImage,
                                    country: countryCode,
                                    availability: size.availability,
                                    isAvailable: size.availability !== 'out_of_stock'
                                };
                                
                                itemsWithData.push(itemWithData);
                                                        } else {
                                // Показываем товар с ошибкой
                                const errorItem = {
                                    ...cartItem,
                                    product: { name: 'Товар недоступен', displayReference: 'N/A' },
                                    displayPrice: 0,
                                    displayImage: null,
                                    isAvailable: false,
                                    error: 'Товар не найден'
                                };
                                itemsWithData.push(errorItem);
                            }
                        });
                    } else {
                        // Показываем все товары данной страны с ошибкой
                        countryItems.forEach(cartItem => {
                            const errorItem = {
                                ...cartItem,
                                product: { name: 'Ошибка загрузки', displayReference: 'N/A' },
                                displayPrice: 0,
                                displayImage: null,
                                isAvailable: false,
                                error: 'Ошибка загрузки данных'
                            };
                            itemsWithData.push(errorItem);
                        });
                    }
                } catch (error) {
                    console.error(`❌ Error loading products for country ${countryCode}:`, error);
                    // Показываем все товары данной страны с ошибкой
                    countryItems.forEach(cartItem => {
                        const errorItem = {
                            ...cartItem,
                            product: { name: 'Ошибка загрузки', displayReference: null },
                            displayPrice: 0,
                            displayImage: null,
                            isAvailable: false,
                            error: 'Ошибка загрузки данных'
                        };
                        itemsWithData.push(errorItem);
                    });
                }
            }
            
            setCartItems(itemsWithData);
        } catch (error) {
            console.error('❌ Error loading cart items:', error);
            setError('Ошибка загрузки корзины');
            setCartItems([]);
        } finally {
            setLoading(false);
        }
    }, [cart]);

    useEffect(() => {
        loadCartItems();
    }, [cart, loadCartItems]);

    const handleUpdateQuantity = (index, newQuantity) => {
        updateQuantity(index, newQuantity);
        loadCartItems();
    };

    const handleRemoveItem = (index) => {
        removeFromCart(index);
        loadCartItems();
    };

    const handleClearCart = () => {
        clearCart();
        setCartItems([]);
    };

    const formatPrice = (price) => {
        return new Intl.NumberFormat('ru-RU', {
            style: 'currency',
            currency: 'RUB',
            minimumFractionDigits: 0
        }).format(price);
    };

    // Вычисляем общую сумму на основе загруженных товаров
    const calculateTotal = () => {
        return cartItems.reduce((total, item) => {
            return total + (item.displayPrice * item.quantity);
        }, 0);
    };

    const cartTotalAmount = calculateTotal();

    const getCountryInfo = (countryCode) => {
        const countryMap = {
            us: { name: "США", flag: "🇺🇸", currency: "$" },
            pl: { name: "Польша", flag: "🇵🇱", currency: "zł" },
            uk: { name: "Великобритания", flag: "🇬🇧", currency: "£" },
            sp: { name: "Испания", flag: "🇪🇸", currency: "€" },
            it: { name: "Италия", flag: "🇮🇹", currency: "€" },
            tr: { name: "Турция", flag: "🇹🇷", currency: "₺" },
            cn: { name: "Китай", flag: "🇨🇳", currency: "¥" },
            vn: { name: "Вьетнам", flag: "🇻🇳", currency: "₫" },
            kz: { name: "Казахстан", flag: "🇰🇿", currency: "₸" },
            by: { name: "Беларусь", flag: "🇧🇾", currency: "Br" }
        };
        return countryMap[countryCode] || { name: countryCode.toUpperCase(), flag: "🏳️", currency: "" };
    };

    const handleCheckout = () => {
        if (cartItems.length === 0) return;
        
        const message = generateOrderMessage();
        const telegramUrl = `https://t.me/olesyalalal?text=${encodeURIComponent(message)}`;
        window.open(telegramUrl, '_blank');
    };

    const handleAskQuestion = () => {
        // Группируем товары по странам для краткой информации
        const groupedByCountry = {};
        cartItems.forEach(item => {
            if (!groupedByCountry[item.country]) {
                groupedByCountry[item.country] = [];
            }
            groupedByCountry[item.country].push(item);
        });
        
        let message = `Здравствуйте! Вопрос по корзине:\n\n💰 Сумма: ${formatPrice(cartTotalAmount)}\n📦 Товаров: ${cartItems.length}\n\n🌍 Страны:\n`;
        
        Object.entries(groupedByCountry).forEach(([countryCode, items]) => {
            const countryInfo = getCountryInfo(countryCode);
            message += `${countryInfo.flag} ${countryInfo.name}: ${items.length} товар\n`;
        });
        
        const telegramUrl = `https://t.me/olesyalalal?text=${encodeURIComponent(message)}`;
        window.open(telegramUrl, '_blank');
    };

    const generateOrderMessage = () => {
        let message = `Здравствуйте, хочу оформить заказ:\n\n`;
        
        // Краткая информация о товарах
        message += `📦 Товаров в корзине: ${cartItems.length}\n`;
        message += `💰 Общая сумма: ${formatPrice(cartTotalAmount)}\n\n`;
        
        // Группируем товары по странам
        const groupedByCountry = {};
        cartItems.forEach(item => {
            if (!groupedByCountry[item.country]) {
                groupedByCountry[item.country] = [];
            }
            groupedByCountry[item.country].push(item);
        });
        
        // Детали по товарам с группировкой по странам
        Object.entries(groupedByCountry).forEach(([countryCode, items]) => {
            const countryInfo = getCountryInfo(countryCode);
            message += `🌍 ${countryInfo.flag} ${countryInfo.name}:\n`;
            
            items.forEach((item, index) => {
                const productUrl = `${window.location.origin}/product/${item.spuId}`;
                message += `${index + 1}. ${item.size || 'N/A'} | ${item.color || 'N/A'} | ${item.quantity}шт | ${formatPrice(item.displayPrice * item.quantity)}\n`;
                message += `   🔗 ${productUrl}\n`;
            });
            message += `\n`;
        });
        
        message += `📱 Детали товаров по ссылкам выше\n\n`;
        message += `Информация о доставке:\n`;
        
        return message;
    };

    return (
        <Container maxWidth="lg" sx={{ px: { xs: 1, sm: 2, md: 3 }, pb: { xs: 12, md: 0 } }}>
            <Box sx={{ mb: { xs: 2, md: 3 } }}>
                <Button
                    startIcon={<ArrowBack />}
                    onClick={() => navigate(-1)}
                    sx={{ mb: { xs: 1, md: 2 } }}
                >
                    Назад
                </Button>
                
                <Typography variant="h4" component="h1" gutterBottom sx={{ 
                    fontSize: { xs: '1.5rem', sm: '2rem', md: '2.125rem' }
                }}>
                    Корзина
                </Typography>
                
                {cartCount > 0 && (
                    <Typography variant="h6" color="text.secondary" sx={{
                        fontSize: { xs: '0.9rem', sm: '1rem', md: '1.25rem' }
                    }}>
                        Товаров в корзине: {cartCount} | Общая сумма: {formatPrice(cartTotalAmount)}
                    </Typography>
                )}
            </Box>



            {/* Основной контент корзины */}
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '40vh', flexDirection: { xs: 'column', sm: 'row' } }}>
                    <CircularProgress size={{ xs: 40, sm: 60 }} />
                    <Typography variant="h6" sx={{ 
                        ml: { xs: 0, sm: 2 }, 
                        mt: { xs: 2, sm: 0 },
                        fontSize: { xs: '1rem', sm: '1.25rem' }
                    }}>
                        Загружаем корзину...
                    </Typography>
                </Box>
            ) : error ? (
                <Alert severity="error" sx={{ mt: 4 }}>
                    {error}
                </Alert>
            ) : cartItems.length === 0 ? (
                <Box sx={{ textAlign: 'center', py: { xs: 6, md: 8 } }}>
                    <Typography variant="h6" color="text.secondary" gutterBottom sx={{
                        fontSize: { xs: '1.1rem', sm: '1.25rem' }
                    }}>
                        Корзина пуста
                    </Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ 
                        mb: { xs: 2, md: 3 },
                        fontSize: { xs: '0.9rem', sm: '1rem' }
                    }}>
                        Добавьте товары в корзину, чтобы продолжить покупки
                    </Typography>
                    <Button
                        variant="contained"
                        onClick={() => navigate('/')}
                        size="large"
                        sx={{
                            py: { xs: 1.5, md: 2 },
                            px: { xs: 3, md: 4 }
                        }}
                    >
                        Перейти к покупкам
                    </Button>
                </Box>
            ) : (
                <Box>
                    {/* Группируем товары по странам */}
                    {(() => {
                        const groupedByCountry = {};
                        cartItems.forEach(item => {
                            if (!groupedByCountry[item.country]) {
                                groupedByCountry[item.country] = [];
                            }
                            groupedByCountry[item.country].push(item);
                        });

                        return Object.entries(groupedByCountry).map(([country, items]) => {
                            const countryInfo = getCountryInfo(country);
                            return (
                                <Box key={country} sx={{ mb: { xs: 4, sm: 4, md: 6 } }}>
                                    <Typography variant="h5" sx={{ 
                                        mb: { xs: 2, sm: 2, md: 4 }, 
                                        pb: { xs: 2, sm: 2, md: 3 }, 
                                        borderBottom: '2px solid #e0e0e0',
                                        display: 'flex',
                                        flexDirection: { xs: 'column', sm: 'row', md: 'row' },
                                        alignItems: { xs: 'flex-start', sm: 'center', md: 'center' },
                                        gap: { xs: 1, sm: 2, md: 2 },
                                        fontSize: { xs: '1.25rem', sm: '1.5rem', md: '1.5rem' }
                                    }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <span style={{ fontSize: { xs: '1.2em', sm: '1.5em' } }}>{countryInfo.flag}</span>
                                            <span>{countryInfo.name}</span>
                                        </Box>
                                        <Typography variant="body1" color="text.secondary" sx={{ 
                                            ml: { xs: 0, sm: 'auto' }, 
                                            fontWeight: 'normal',
                                            fontSize: { xs: '0.875rem', sm: '1rem' }
                                        }}>
                                            ({items.length} товар{items.length === 1 ? '' : items.length < 5 ? 'а' : 'ов'})
                                        </Typography>
                                    </Typography>
                                    
                           
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 2, sm: 2, md: 3 } }}>
                                        {items.map((item, itemIndex) => (
                                            <Card key={`${item.spuId}-${item.skuId}-${itemIndex}`} sx={{ 
                                                display: 'flex', 
                                                flexDirection: { xs: 'column', sm: 'column', md: 'row' },
                                                minHeight: { xs: 'auto', sm: 'auto', md: 160 },
                                                height: { xs: 'auto', sm: 'auto', md: 160 },
                                                borderRadius: { xs: 1, md: 2 },
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                                '&:hover': {
                                                    boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
                                                    transition: 'all 0.2s ease'
                                                }
                                            }}>
                                                {/* Изображение товара */}
                                                <Box sx={{ 
                                                    width: { xs: '100%', sm: '100%', md: 160 }, 
                                                    height: { xs: 180, sm: 200, md: '100%' },
                                                    flexShrink: 0, 
                                                    p: { xs: 0.5, md: 1 },
                                                    bgcolor: '#fafafa',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    overflow: 'hidden'
                                                }}>
                                                    {item.displayImage ? (
                                                        <img
                                                            src={item.displayImage}
                                                            alt={item.product?.name || 'Product'}
                                                            style={{
                                                                width: '100%',
                                                                height: '100%',
                                                                objectFit: 'contain',
                                                                cursor: 'pointer'
                                                            }}
                                                            onClick={() => navigate(`/product/${item.spuId}`)}
                                                        />
                                                    ) : (
                                                        <Box sx={{ 
                                                            width: '100%', 
                                                            height: '100%', 
                                                            bgcolor: 'grey.200',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            cursor: 'pointer'
                                                        }}
                                                        onClick={() => navigate(`/product/${item.spuId}`)}>
                                                            <Typography variant="body2" color="text.secondary">
                                                                Нет фото
                                                            </Typography>
                                                        </Box>
                                                    )}
                                                </Box>
                                                
                                                                                            {/* Информация о товаре */}
                                            <Box sx={{ 
                                                flex: 1, 
                                                p: { xs: 1.5, sm: 2, md: 3 }, 
                                                display: 'flex', 
                                                flexDirection: 'column', 
                                                justifyContent: 'space-between' 
                                            }}>
                                                <Box>
                                                    <Typography 
                                                        variant="h6" 
                                                        sx={{ 
                                                            mb: { xs: 0.5, md: 1 }, 
                                                            fontSize: { xs: '0.9rem', sm: '1rem', md: '1.25rem' },
                                                            cursor: 'pointer',
                                                            '&:hover': {
                                                                color: 'primary.main',
                                                                textDecoration: 'underline'
                                                            }
                                                        }}
                                                        onClick={() => navigate(`/product/${item.spuId}`)}
                                                    >
                                                        {item.product?.name || 'Название товара не найдено'}
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary" sx={{ 
                                                        mb: 0.5,
                                                        fontSize: { xs: '0.75rem', sm: '0.875rem' }
                                                    }}>
                                                        Размер: {item.size || 'Не выбран'} | Цвет: {item.color || 'Не выбран'}
                                                    </Typography>
                                                    <Typography 
                                                        variant="body2" 
                                                        color="text.secondary"
                                                        sx={{
                                                            cursor: 'pointer',
                                                            fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                                            '&:hover': {
                                                                color: 'primary.main',
                                                                textDecoration: 'underline'
                                                            }
                                                        }}
                                                        onClick={() => navigate(`/product/${item.spuId}`)}
                                                    >
                                                        Артикул: {item.product?.displayReference || 'N/A'}
                                                    </Typography>
                                                    
                                                    {/* Отображение ошибок */}
                                                    {item.error && (
                                                        <Alert severity="warning" sx={{ mt: 1, mb: 1 }}>
                                                            <Typography variant="body2">
                                                                ⚠️ {item.error}
                                                            </Typography>
                                                        </Alert>
                                                    )}
                                                </Box>
                                                
                                                <Box sx={{ 
                                                    display: 'flex', 
                                                    flexDirection: { xs: 'column', sm: 'row', md: 'row' },
                                                    alignItems: { xs: 'flex-start', sm: 'center', md: 'center' }, 
                                                    justifyContent: 'space-between',
                                                    gap: { xs: 1.5, sm: 2, md: 0 }
                                                }}>
                                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 0.5, sm: 0.5, md: 0.5 } }}>
                                                        <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem', md: '0.875rem' } }}>
                                                            Цена за единицу: {formatPrice(item.displayPrice)}
                                                        </Typography>
                                                        <Typography variant="body1" color="primary" sx={{ 
                                                            fontWeight: 'bold',
                                                            fontSize: { xs: '1.1rem', sm: '1rem', md: '1.25rem' }
                                                        }}>
                                                            {formatPrice(item.displayPrice * item.quantity)}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Box>
                                            
                                            {/* Кнопки действий - объединены на мобильных */}
                                                <Box sx={{ 
                                                    p: { xs: 1, sm: 2, md: 3 }, 
                                                    display: 'flex', 
                                                    alignItems: 'center',
                                                    justifyContent: { xs: 'space-between', sm: 'center', md: 'flex-start' },
                                                    gap: { xs: 1, sm: 0 }
                                                }}>
                                                    {/* На мобильных показываем кнопки в одну строку */}
                                                    <Box sx={{ 
                                                        display: { xs: 'flex', md: 'none' }, 
                                                        alignItems: 'center', 
                                                        gap: 1,
                                                        flex: 1,
                                                        justifyContent: 'space-between'
                                                    }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                            <IconButton
                                                                size="small"
                                                                onClick={() => handleUpdateQuantity(cartItems.indexOf(item), Math.max(1, item.quantity - 1))}
                                                                sx={{ 
                                                                    border: '1px solid #ddd',
                                                                    '&:hover': { 
                                                                        bgcolor: '#f5f5f5'
                                                                    }
                                                                }}
                                                            >
                                                                <Remove />
                                                            </IconButton>
                                                            <Typography variant="body2" sx={{ minWidth: 25, textAlign: 'center', fontSize: '0.875rem' }}>
                                                                {item.quantity}
                                                            </Typography>
                                                            <IconButton
                                                                size="small"
                                                                onClick={() => handleUpdateQuantity(cartItems.indexOf(item), item.quantity + 1)}
                                                                sx={{ 
                                                                    border: '1px solid #ddd',
                                                                    '&:hover': { 
                                                                        bgcolor: '#f5f5f5'
                                                                    }
                                                                }}
                                                            >
                                                                <Add />
                                                            </IconButton>
                                                        </Box>
                                                        
                                                        <IconButton
                                                            onClick={() => handleRemoveItem(cartItems.indexOf(item))}
                                                            size="small"
                                                            sx={{ 
                                                                border: '1px solid #000',
                                                                color: '#000',
                                                                '&:hover': { 
                                                                    bgcolor: '#000', 
                                                                    color: 'white',
                                                                    borderColor: '#000'
                                                                }
                                                            }}
                                                        >
                                                            <Delete />
                                                        </IconButton>
                                                    </Box>
                                                    
                                                    {/* На десктопе показываем кнопки количества и удаления */}
                                                    <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 2 }}>
                                                        {/* Кнопки изменения количества */}
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                            <IconButton
                                                                size="small"
                                                                onClick={() => handleUpdateQuantity(cartItems.indexOf(item), Math.max(1, item.quantity - 1))}
                                                                sx={{ 
                                                                    border: '1px solid #ddd',
                                                                    '&:hover': { 
                                                                        bgcolor: '#f5f5f5'
                                                                    }
                                                                }}
                                                            >
                                                                <Remove />
                                                            </IconButton>
                                                            <Typography variant="body2" sx={{ minWidth: 25, textAlign: 'center', fontSize: '0.875rem' }}>
                                                                {item.quantity}
                                                            </Typography>
                                                            <IconButton
                                                                size="small"
                                                                onClick={() => handleUpdateQuantity(cartItems.indexOf(item), item.quantity + 1)}
                                                                sx={{ 
                                                                    border: '1px solid #ddd',
                                                                    '&:hover': { 
                                                                        bgcolor: '#f5f5f5'
                                                                    }
                                                                }}
                                                            >
                                                                <Add />
                                                            </IconButton>
                                                        </Box>
                                                        
                                                        {/* Кнопка удаления */}
                                                        <IconButton
                                                            onClick={() => handleRemoveItem(cartItems.indexOf(item))}
                                                            size="small"
                                                            sx={{ 
                                                                border: '1px solid #000',
                                                                color: '#000',
                                                                '&:hover': { 
                                                                    bgcolor: '#000', 
                                                                    color: 'white',
                                                                    borderColor: '#000'
                                                                }
                                                            }}
                                                        >
                                                            <Delete />
                                                        </IconButton>
                                                    </Box>
                                                </Box>
                                            </Card>
                                        ))}
                                    </Box>
                                </Box>
                            );
                        });
                    })()}
                </Box>
            )}

            {cartItems.length > 0 && (
                <Box sx={{ mt: { xs: 3, md: 4 }, textAlign: 'center' }}>
                    <Box sx={{ 
                        display: 'flex', 
                        flexDirection: { xs: 'column', sm: 'row' }, 
                        gap: { xs: 2, sm: 2 }, 
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            onClick={handleCheckout}
                            fullWidth={false}
                            sx={{ 
                                minWidth: { xs: '200px', sm: 'auto' },
                                py: { xs: 1.5, md: 2 }
                            }}
                        >
                            Оформить заказ
                        </Button>
                        <Button
                            variant="outlined"
                            color="primary"
                            size="large"
                            onClick={handleAskQuestion}
                            fullWidth={false}
                            sx={{ 
                                minWidth: { xs: '200px', sm: 'auto' },
                                py: { xs: 1.5, md: 2 }
                            }}
                        >
                            Задать вопрос
                        </Button>
                        <Button
                            variant="outlined"
                            color="error"
                            size="large"
                            onClick={handleClearCart}
                            fullWidth={false}
                            sx={{ 
                                minWidth: { xs: '200px', sm: 'auto' },
                                py: { xs: 1.5, md: 2 }
                            }}
                        >
                            Очистить корзину
                        </Button>
                    </Box>
                </Box>
            )}

            {/* Мобильный бар внизу экрана */}
            {cartItems.length > 0 && (
                <Box sx={{
                    display: { xs: 'block', md: 'none' },
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    backgroundColor: 'white',
                    borderTop: '1px solid #e0e0e0',
                    boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
                    zIndex: 1000,
                    p: 2
                }}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2
                    }}>
                        {/* Общая сумма */}
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            px: 1
                        }}>
                            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                Общая сумма:
                            </Typography>
                            <Typography variant="h6" color="primary" sx={{ fontWeight: 'bold' }}>
                                {formatPrice(cartTotalAmount)}
                            </Typography>
                        </Box>

                        {/* Кнопки действий */}
                        <Box sx={{
                            display: 'flex',
                            gap: 1
                        }}>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={handleCheckout}
                                sx={{
                                    py: 1.5,
                                    textTransform: 'none',
                                    fontSize: '1rem',
                                    fontWeight: 'bold'
                                }}
                            >
                                Оформить заказ
                            </Button>
                            <Button
                                variant="outlined"
                                color="primary"
                                fullWidth
                                onClick={handleAskQuestion}
                                sx={{
                                    py: 1.5,
                                    textTransform: 'none',
                                    fontSize: '0.9rem',
                                    borderWidth: '2px'
                                }}
                            >
                                Задать вопрос
                            </Button>
                        </Box>
                    </Box>
                </Box>
            )}
        </Container>
    );
};

export default Cart;
